//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            checkStrictly: false,
            data: [],
            columns: [],
            rowSelection: {},
            formState: {
                options: '0'
            }
        }
    },
    mounted() {
        this.columns.push({ title: '會員賬戶', dataIndex: 'username', key: 'username', })
        this.columns.push({ title: '會員手機號', dataIndex: 'cellphone', key: 'cellphone', })
        this.columns.push({ title: '會員姓名', dataIndex: 'name', key: 'name', })
        this.columns.push({ title: '操作類型', dataIndex: 'optionType', key: 'optionType', })
        this.columns.push({ title: '操作內容', dataIndex: 'options', key: 'options', })
        this.columns.push({ title: '操作時間', dataIndex: 'time', key: 'time', })
        this.columns.push({ title: '操作IP', dataIndex: 'ip', key: 'ip', })
        this.data.push({
            username: '用戶00001',
            cellphone: '09000000',
            name: '張先生',
            optionType: '註冊會員',
            options: '完成註冊',
            time: '2025-06-08 20:00:05',
            ip: '192.168.1.1'
        })
        this.data.push({
            username: '用戶00001',
            cellphone: '09000000',
            name: '張先生',
            optionType: '登入',
            options: '成功',
            time: '2025-06-08 20:00:05',
            ip: '192.168.1.1'
        })
        this.data.push({
            username: '用戶00001',
            cellphone: '09000000',
            name: '張先生',
            optionType: '報名繳費',
            options: '成功報名課程 課程1',
            time: '2025-06-08 20:00:05',
            ip: '192.168.1.1'
        })
    },
    methods: {
        handleFinish() {

        },
        handleFinishFailed() {

        },
    }
}
